import { TextField } from '@nike/eds'
import { HTMLAttributes } from 'react'
import './MultilineSearchInput.css'

export interface SingleLineInputProps
  extends Omit<
      React.ComponentPropsWithoutRef<typeof TextField>,
      'id' | 'name' | 'value' | 'defaultValue' | 'onBlur'
    >,
    HTMLAttributes<HTMLInputElement> {
  name: string
  label: string
  value?: any
  onChange: any
  beforeSlot?: any
}

export function SinglelineSearchInput({
  name,
  label,
  value = '',
  onChange,
  beforeSlot,
  type = 'text',
  width = 185,
  ...otherProps
}: SingleLineInputProps) {
  return (
    <div className="">
      <label className="search-label">{label}</label>
      <TextField
        id={`${name}Input`}
        value={value}
        label={label}
        name={name}
        onChange={onChange}
        beforeSlot={beforeSlot}
        hideLabel={true}
        type={type}
        {...otherProps}
        style={{
          width: `${width}px`,
          padding: beforeSlot
            ? 'var(--eds-space-8) var(--eds-space-4) 9px 36px'
            : 'var(--eds-space-8) var(--eds-space-4) 9px var(--eds-space-8)',
        }}
      ></TextField>
    </div>
  )
}
